import {cloneDeep} from 'lodash';
import {BaseContextTool} from '../common/base-context-tool';
import {ContextBarOptionGroup, ContextBarIconOption} from '@q9elements/ui-kit/components';
import {MxCell} from 'src/app/editor-interface/shared/models/mx-cell.interface';
import {contextBarModel, subMenuIcons} from './context-bar-model';
import {SelectionTypes} from 'src/app/shared/models/diagram-interactions.interface';
import {MenuItem} from '../../shared/models/mx-menu-item-meta.interface';
import {Action} from '../actions/actions-hub';
import {menuItems} from '../context-menu/menu-items';

export abstract class BaseContextBar extends BaseContextTool {
  abstract getOptions(): ContextBarOptionGroup[] | null;
  abstract selectionType: SelectionTypes;

  private get optionNames() {
    return this.registry.resources;
  }

  private get actions() {
    return this.registry.getEditorUI().actions.actions;
  }

  protected get selectedCell(): MxCell {
    return this.registry.getGraph().getSelectionCell();
  }

  protected createMenuItemOption(name: string): ContextBarIconOption {
    let menuItem = contextBarModel[this.selectionType][name];

    if (name === menuItems.drilldown) {
      menuItem = this.getDrilldownOptions(menuItem);
    }

    if (this.isSubmenu(menuItem)) {
      return this.getSubmenuListOption(menuItem, name);
    }

    return this.getActionOption(name, menuItem);
  }

  private getSubmenuListOption(item: MenuItem, itemName?: string) {
    const subOptions = this.getVisibleSubOptions(item.items);

    return {
      name: this.optionNames[item.title],
      icon: item.icon,
      iconColor: item.iconColor,
      tooltip: item.tooltip ?? this.optionNames[itemName],
      hidden: !subOptions.length,
      subOptions
    };
  }

  private getActionOption(itemName: string, item?: MenuItem) {
    const action = this.actions[itemName];
    const isActive = action?.isActive();

    return {
      name: this.optionNames[item?.title ?? itemName],
      icon: item?.icon ?? subMenuIcons[itemName],
      iconColor: item?.iconColor,
      tooltip: item ? (item.tooltip ?? this.optionNames[itemName]) : action?.rowTitle?.() || '',
      q9Track: item?.q9Track ?? this.getQ9TrackValue(action),
      hidden: !action?.isEnabled(),
      disabled: isActive === false,
      action: action?.funct
    };
  }

  private getVisibleSubOptions(items: (MenuItem | string)[]) {
    return items
      .map((item: MenuItem | string) =>
        this.isSubmenu(item)
          ? this.getSubmenuListOption(item as MenuItem)
          : this.getActionOption(item as string)
      )
      .filter(option => !option.hidden);
  }

  private isSubmenu(item: MenuItem | string): boolean {
    return typeof item === 'object' && !!item.items?.length;
  }

  private getQ9TrackValue(action: Action): string | undefined {
    return action?.attributes
      ?.find(attr => attr.name === 'q9track')
      ?.value?.replace('context_menu', 'context_toolbar');
  }

  private getDrilldownOptions(menuItem): MenuItem {
    const menuItemCopy = cloneDeep(menuItem);

    menuItemCopy.items = this.getDrilldownMenuItems();

    return menuItemCopy;
  }
}
